import script from "./POI.vue?vue&type=script&setup=true&lang=js"
export * from "./POI.vue?vue&type=script&setup=true&lang=js"

import "./POI.vue?vue&type=style&index=0&id=0401cadf&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0401cadf"]])

export default __exports__